import { Rating } from '@/types';
import { FacilityType } from '@/types/enums/facility-type.enum';
import { ProcedureTypeEnum } from '@/types/enums/procedure-type.enum';
import type { SchedulesSearchSlot } from '@/app/(main)/(pages)/_components/schedules/_types/schedule-slot.type';
import { ScheduleType } from '@/app/(main)/(pages)/_components/schedules/_types/schedule-type.enum';

export { SlotStatus } from '@/app/(main)/(pages)/_components/schedules/_types/schedule-slot.type';
export type { SchedulesSearchSlot } from '@/app/(main)/(pages)/_components/schedules/_types/schedule-slot.type';
export { ScheduleType } from '@/app/(main)/(pages)/_components/schedules/_types/schedule-type.enum';
export { FacilityType, ProcedureTypeEnum };

export interface SchedulesSearchPartnerFacilityContacts {
  email: string;
  phones: string[];
  whatsapp: string;
}

export enum SearchType {
  ALL = 'ALL',
  LABORATORIAL_EXAM = 'LABORATORIAL_EXAM',
  ONLINE_CONSULTATION = 'ONLINE_CONSULTATION',
  PRESENTIAL_CONSULTATION = 'PRESENTIAL_CONSULTATION',
  DOCTOR = 'DOCTOR',
  VACCINE = 'VACCINE',
  IMAGE_EXAM = 'IMAGE_EXAM',
  CLINIC = 'CLINIC',
  EMERGENCY = 'EMERGENCY',
  SURGERY = 'SURGERY',
  BRANCH_LABORATORY = 'BRANCH_LABORATORY',
}

export interface SchedulesSearchProcedure {
  id: string;
  name: string;
  code: string;
  codes?: string[];
  label?: string;
  type: ProcedureTypeEnum;
  tussCode: string;
  description: string;
  instructions: string;
  originalPrice?: number;
  price?: number;
  selected?: boolean;
  availableForTelehealth: boolean;
  searchType: SearchType;
  slug?: string;
  isAvailable: boolean;
  promotionId?: string;
}

export interface SchedulesSearchPartnerFacility {
  IBGECode: string;
  id: string;
  addressLine1: string;
  addressLine2?: string | undefined;
  city: string;
  contacts: SchedulesSearchPartnerFacilityContacts;
  name: string;
  neighborhood: string;
  number: string;
  rating?: Rating;
  state: string;
  type: FacilityType;
  zipcode: string;
  slug?: string;
}

export interface SchedulesSearchPartner {
  avatar: string;
  distance: string;
  description: string;
  facility: SchedulesSearchPartnerFacility;
  id: string;
  score: number;
  socialName: string;
}

export interface SchedulesSearchProfessionalLicenses {
  councilInitials: string;
  specialistQualificationRecord: string;
  specialtyName: string;
  professionalLicenseRecord: string;
  professionalLicenseState: string;
  isDisplayed: boolean;
}

export interface SchedulesSearchProfessional {
  avatar: string;
  honorific: string;
  gender?: string;
  id: string;
  name: string;
  slug: string;
  rating: Rating;
  licenses: SchedulesSearchProfessionalLicenses[];
  createdAt: string;
}

export interface SchedulePeriodDto {
  id: string;
  start: string;
  end: string;
  duration: number;
  weekday: number;
}

export interface ScheduleSearch {
  id: string;
  type: string;
  slots: SchedulesSearchSlot[];
  workingPeriods: SchedulePeriodDto[];
  notes?: string;
  waitingTime?: string;
  name?: string;
  minAge: number;
  maxAge: number;
  followUp?: number;
}

export interface SearchPartnerData {
  distance?: number;
  partner: SchedulesSearchPartner;
  priceScore: string | number;
  procedures: SchedulesSearchProcedure[];
  description: string;
  proceduresFoundScore: number;
  professional: SchedulesSearchProfessional;
  schedulesTypes: Record<ScheduleType, ScheduleSearch[]>;
  score: string | number;
  timeOffset: string;
  timeZone: string;
}
